import type { ModelAddButtonProps } from "./model-add-button.type";

import { useAuthorization } from "@/modules/authorization";

import ModelAddButton from "./model-add-button.component";

const ModelAddButtonWrapper = (props: ModelAddButtonProps) => {
  const { canCreate } = useAuthorization();

  if (!canCreate(props.model)) return null;

  return <ModelAddButton {...props} />;
};

export default ModelAddButtonWrapper;
